module.exports = __webpack_public_path__ + "static/media/me3_Laptop.13e42954.svg";